import { Component } from '@angular/core';

/**
 * Dummy component for Auth0 login callbacks.
 * AuthService handles the callback internally, this component is just for routing purposes
 */
@Component({
  selector: 'qm-callback',
  templateUrl: 'callback.component.html'
})
export class CallbackComponent { }
